import React, { useEffect, useState } from "react";
import backArrow from "../assets/dashboardBackArrow.png";
import info from "../assets/resultInfo.svg";
import "../styles/ResultOverView.css";
import Loader, { LocalStorage } from "../../../utils/Utils";
import { useApi } from "../../../service/ApiContext";
import {
  AnswerResponse,
  AssessmentQuestionResult,
  ResultOverViewResponse,
} from "../data/interface/AssessmentChartInterfaces";
import { useLocation, useNavigate } from "react-router-dom";
import { DomainScore } from "../../student_dashboard/skill_score/interface/ScoreResponse_Interface";
import { Tooltip } from "@mui/material";
import { useAlert } from "../../../components/AlertContextComponent";
import { useDispatch } from "react-redux";
import { setSelectedToggle } from "../data/redux/GradedPopQuizRedux";
import incorrect from "../assets/inCorrectPlaceHolder.svg";
import correct from "../assets/correctPlaceholder.svg";
const ResultOverView: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<
    "all" | "correct" | "incorrect"
  >("all");
  const navigate = useNavigate();
  const location = useLocation();
  const api = useApi();
  const state = location.state;
  const [totalCount, setTotalCount] = useState<number>();
  const [correctCount, setCorrectCount] = useState<number>();
  const [questions, setQuestions] = useState<AssessmentQuestionResult[]>([]);
  const [answerOptions, setAnswerOptions] = useState<AnswerResponse[]>([]);
  const [domainScore, setDomainScore] = useState<number>();
  const dispatch = useDispatch();

  const resultOverviewApi = async (result: string) => {
    Loader.showLoading();
    try {
      api.setAuthToken(LocalStorage.getLocalData("access_token"));
      const queryParams = new URLSearchParams();
      queryParams.append("domain_id", state.domain_data.domain_id);

      queryParams.append(
        "domain_type",
        state.performance === "Curriculum" ? "Curriculum" : "Program",
      );

      queryParams.append("assessment_id", state.data.assessment_id);

      queryParams.append("result_type", result);

      const res = await api.get<ResultOverViewResponse>(
        `/candidate_result?${queryParams.toString()}`,
      );

      if (res.data) {
        setTotalCount(res.data.total_questions);
        setCorrectCount(res.data.correct_questions);
        setQuestions(res.data.questions);
        setDomainScore(res.data.domain_score);
      } else {
      }
    } catch (e) {
      // showAlert({
      //   identity: "default",
      //   show: true,
      //   title:"error",
      //   message: ,
      //   button1Text: "Ok",
      //   alertType: "error",
      //   onlyNeedOneButton: true,
      // });
    } finally {
      Loader.dismissLoading();
    }
  };

  useEffect(() => {
    resultOverviewApi("all");
  }, []);

  const toggleOptions = [
    { id: "all" as const, label: "All" },
    { id: "correct" as const, label: "Correct" },
    { id: "incorrect" as const, label: "Incorrect" },
  ];

  const getDomainScoreUI = (score?: number) => {
    if (score! >= 0 && score! <= 40) {
      return {
        backgroundColor: "#DF3030", // red
        label: "Disoriented",
      };
    }

    if (score! > 40 && score! < 80) {
      return {
        backgroundColor: "#F7921B", // yellow
        label: "Interested",
      };
    }

    return {
      backgroundColor: "#24C782", // green
      label: "Strength",
    };
  };
  const renderSqlQuestion = (q: AssessmentQuestionResult, index: number) => (
    <div
      key={q.question_id}
      className={`result-card ${q.is_correct ? "correct" : "wrong"}`}
    >
      {/* Header */}
      <div className="result-card-header">
        <div className="result-question">
          {index + 1}. {q.question}
        </div>
        <div className="result-difficulty">{q.difficulty_level} • SQL</div>
      </div>

      {/* Problem Statement */}
      {q.problem_statement && (
        <div className="result-problem-statement">
          <strong>Problem Statement:</strong>
          <div
            className="problem-statement-content"
            style={{
              whiteSpace: "pre-wrap",
              backgroundColor: "#ffffff",
              padding: "12px",
              borderRadius: "6px",
              marginTop: "8px",
              fontSize: "14px",
              lineHeight: "1.6",
              border: "1px solid #e0e0e0",
            }}
          >
            {q.problem_statement}
          </div>
        </div>
      )}

      {/* Feedback for SQL */}
      {q.feedback && (
        <div className="result-feedback">
          <strong>Feedback:</strong>
          <div
            className="feedback-content"
            style={{
              backgroundColor: "#ffffff",
              padding: "12px",
              borderRadius: "6px",
              marginTop: "8px",
              fontSize: "14px",
              lineHeight: "1.6",
              border: "1px solid #e0e0e0",
            }}
          >
            {/* Feedback Summary */}
            <div style={{ marginBottom: "12px" }}>
              <span style={{ fontWeight: "bold", color: "#e65100" }}>
                Feedback Summary:
              </span>{" "}
              <span style={{ color: q.is_correct ? "#24C782" : "#DF3030" }}>
                {q.feedback.feedback_summary ||
                  (q.is_correct ? "Correct! ✅" : "Incorrect")}
              </span>
            </div>

            {/* Scores */}
            <div style={{ marginBottom: "8px" }}>
              <span style={{ fontWeight: "bold", color: "#e65100" }}>
                Correctness Score:
              </span>{" "}
              {q.feedback.correctness_score}/100
            </div>

            <div style={{ marginBottom: "12px" }}>
              <span style={{ fontWeight: "bold", color: "#e65100" }}>
                Final Score:
              </span>{" "}
              {q.feedback.final_score}/100
            </div>

            {/* Performance Metrics */}
            {q.feedback.candidate_execution_time_ms && (
              <div style={{ marginBottom: "12px" }}>
                <span style={{ fontWeight: "bold", color: "#e65100" }}>
                  Performance:
                </span>
                <div style={{ marginTop: "4px", marginLeft: "12px" }}>
                  <div>
                    Execution Time: {q.feedback.candidate_execution_time_ms} ms
                  </div>
                  <div>
                    Reference Time: {q.feedback.reference_execution_time_ms} ms
                  </div>
                  {q.feedback.performance_ratio && (
                    <div>
                      Performance Ratio: {q.feedback.performance_ratio}x
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Missing/Extra Columns */}
            {q.feedback.missing_columns &&
              q.feedback.missing_columns.length > 0 && (
                <div style={{ marginBottom: "12px" }}>
                  <span style={{ fontWeight: "bold", color: "#e65100" }}>
                    Missing Columns:
                  </span>
                  <ul style={{ marginTop: "4px" }}>
                    {q.feedback.missing_columns.map((col, idx) => (
                      <li key={idx} style={{ marginLeft: "20px" }}>
                        {col}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

            {q.feedback.extra_columns &&
              q.feedback.extra_columns.length > 0 && (
                <div style={{ marginBottom: "12px" }}>
                  <span style={{ fontWeight: "bold", color: "#e65100" }}>
                    Extra Columns:
                  </span>
                  <ul style={{ marginTop: "4px" }}>
                    {q.feedback.extra_columns.map((col, idx) => (
                      <li key={idx} style={{ marginLeft: "20px" }}>
                        {col}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

            {/* Suggestions */}
            {q.feedback.suggestions && (
              <div>
                <span style={{ fontWeight: "bold", color: "#e65100" }}>
                  Suggestions:
                </span>
                <div style={{ marginTop: "4px" }}>{q.feedback.suggestions}</div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
  const renderProgrammingQuestion = (
    q: AssessmentQuestionResult,
    index: number,
  ) => (
    <div
      key={q.question_id}
      className={`result-card ${q.is_correct ? "correct" : "wrong"}`}
    >
      {/* Header */}
      <div className="result-card-header">
        <div className="result-question">
          {index + 1}. {q.question}
        </div>
        <div className="result-difficulty">
          {q.difficulty_level} • {q.programming_language}
        </div>
      </div>

      {/* Problem Statement */}
      {q.problem_statement && (
        <div className="result-problem-statement">
          <strong>Problem Statement:</strong>
          <div
            className="problem-statement-content"
            style={{
              whiteSpace: "pre-wrap",
              backgroundColor: "#ffffff", // Changed to white
              padding: "12px",
              borderRadius: "6px",
              marginTop: "8px",
              fontSize: "14px",
              lineHeight: "1.6",
              border: "1px solid #e0e0e0", // Added subtle border for definition
            }}
          >
            {q.problem_statement}
          </div>
        </div>
      )}

      {/* Your Answer */}
      {q.your_answer && (
        <div className="result-your-answer">
          <strong>Your Answer:</strong>
          <div className="answer-text">{q.your_answer.answer}</div>
        </div>
      )}

      {/* Correct Answer */}
      {q.correct_answer && (
        <div className="result-correct-answer">
          <strong>Correct Answer:</strong>
          <div className="answer-text correct">{q.correct_answer.answer}</div>
        </div>
      )}

      {/* Feedback with Subheadings */}
      {q.feedback && (
        <div className="result-feedback">
          <strong>Feedback:</strong>
          <div
            className="feedback-content"
            style={{
              backgroundColor: "#ffffff", // Changed to white
              padding: "12px",
              borderRadius: "6px",
              marginTop: "8px",
              fontSize: "14px",
              lineHeight: "1.6",
              whiteSpace: "pre-wrap",
              border: "1px solid #e0e0e0", // Added subtle border for definition
            }}
          >
            {/* Code Quality Score */}
            <div style={{ marginBottom: "12px" }}>
              <span style={{ fontWeight: "bold", color: "#e65100" }}>
                Code Quality Score:
              </span>{" "}
              {q.feedback.code_quality_score}/100
            </div>

            {/* Code Review Feedback */}
            {q.feedback.code_review_feedback && (
              <div style={{ marginBottom: "12px" }}>
                <span style={{ fontWeight: "bold", color: "#e65100" }}>
                  Code Review:
                </span>
                <div style={{ marginTop: "4px" }}>
                  {q.feedback.code_review_feedback}
                </div>
              </div>
            )}
            {/* Positive Aspects */}
            {q.feedback.positive_aspects &&
              q.feedback.positive_aspects.length > 0 && (
                <div>
                  <span
                    style={{
                      fontWeight: "bold",
                      color: "#e65100",
                    }}
                  >
                    Positive Aspects:
                  </span>
                  <ul style={{ marginTop: "4px", marginBottom: "12px" }}>
                    {q.feedback.positive_aspects.map((aspect, idx) => (
                      <li key={idx} style={{ marginLeft: "20px" }}>
                        {aspect}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

            {/* Complexity Analysis */}
            <div style={{ marginBottom: "12px" }}>
              <span style={{ fontWeight: "bold", color: "#e65100" }}>
                Complexity Analysis:
              </span>
              <div style={{ marginTop: "4px" }}>
                <div>
                  <span style={{ fontStyle: "italic" }}>Time Complexity:</span>{" "}
                  {q.feedback.time_complexity}
                </div>
                <div>
                  <span style={{ fontStyle: "italic" }}>Space Complexity:</span>{" "}
                  {q.feedback.space_complexity}
                </div>
              </div>
            </div>

            {/* Best Practices Violations */}
            {q.feedback.best_practices_violations &&
              q.feedback.best_practices_violations.length > 0 && (
                <div style={{ marginBottom: "12px" }}>
                  <span style={{ fontWeight: "bold", color: "#e65100" }}>
                    Best Practices Violations:
                  </span>
                  <ul style={{ marginTop: "4px", marginBottom: "0" }}>
                    {q.feedback.best_practices_violations.map(
                      (violation, idx) => (
                        <li key={idx} style={{ marginLeft: "20px" }}>
                          {violation}
                        </li>
                      ),
                    )}
                  </ul>
                </div>
              )}

            {/* Optimization Suggestions */}
            {q.feedback.optimization_suggestions &&
              q.feedback.optimization_suggestions.length > 0 && (
                <div style={{ marginBottom: "12px" }}>
                  <span style={{ fontWeight: "bold", color: "#e65100" }}>
                    Optimization Suggestions:
                  </span>
                  <ul style={{ marginTop: "4px", marginBottom: "0" }}>
                    {q.feedback.optimization_suggestions.map(
                      (suggestion, idx) => (
                        <li key={idx} style={{ marginLeft: "20px" }}>
                          {suggestion}
                        </li>
                      ),
                    )}
                  </ul>
                </div>
              )}

            {/* Recommended Approach */}
            {q.feedback.recommended_approach && (
              <div style={{ marginBottom: "12px" }}>
                <span style={{ fontWeight: "bold", color: "#e65100" }}>
                  Recommended Approach:
                </span>
                <div
                  style={{
                    marginTop: "4px",
                    backgroundColor: "#f8f9fa", // Light gray background for code block
                    padding: "8px",
                    borderRadius: "4px",
                    fontFamily: "monospace",
                    whiteSpace: "pre-wrap",
                    border: "1px solid #e0e0e0", // Added subtle border
                  }}
                >
                  {q.feedback.recommended_approach}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Explanation */}
      {q.explanation && (
        <div className="result-explanation">
          <strong>Explanation:</strong>
          <div
            className="explanation-content"
            style={{
              backgroundColor: "#ffffff", // Changed to white
              padding: "12px",
              borderRadius: "6px",
              marginTop: "8px",
              fontSize: "14px",
              lineHeight: "1.6",
              border: "1px solid #e0e0e0", // Added subtle border for definition
            }}
          >
            {q.explanation}
          </div>
        </div>
      )}
    </div>
  );

  const renderMultipleChoiceQuestion = (
    q: AssessmentQuestionResult,
    index: number,
  ) => (
    <div
      key={q.question_id}
      className={`result-card ${q.is_correct ? "correct" : "wrong"}`}
    >
      {/* Header */}
      <div className="result-card-header">
        <div className="result-question">
          {index + 1}. {q.question}
        </div>
        <div className="result-difficulty">{q.difficulty_level}</div>
      </div>

      {/* Answers */}
      <div className="result-answers">
        {/* Your Answer */}
        {q.your_answer && (
          <div>
            <div className="result-label">Your Answer:</div>
            <div className="result-answer-row">
              <span className="answer-text">{q.your_answer.answer}</span>
            </div>
          </div>
        )}

        {/* Correct Answer */}
        {q.correct_answer && (
          <div>
            <div className="result-label">Correct Answer:</div>
            <div className="result-answer-row">
              <span className="answer-text correct">
                {q.correct_answer.answer}
              </span>
            </div>
          </div>
        )}
      </div>

      {/* Explanation */}
      {q.explanation && (
        <div className="result-explanation">
          <strong>Explanation:</strong>
          <div>{q.explanation}</div>
        </div>
      )}
    </div>
  );

  const renderEmptyState = () => {
    if (selectedOption === "correct") {
      return (
        <div
          style={{
            fontSize: "18px",
            fontWeight: "500",
            color: "#999",
            display: "flex",
            flexDirection: "column", // stack vertically
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            textAlign: "center",
          }}
        >
          <div>
            <img
              src={correct}
              style={{
                height: "350px",
                width: "470px",
              }}
              alt="No correct answers"
            />
          </div>
          <span
            style={{
              fontFamily: "Mazzard",
              color: "#272727",
              fontWeight: "600",
            }}
          >
            Learners have no correctly answered questions
          </span>
        </div>
      );
    }

    if (selectedOption === "incorrect") {
      return (
        <div
          style={{
            fontSize: "18px",
            fontWeight: "500",
            color: "#999",
            display: "flex",
            flexDirection: "column", // stack vertically
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            textAlign: "center",
          }}
        >
          <img
            src={incorrect}
            style={{
              height: "350px",
              width: "470px",
            }}
            alt="No incorrect answers"
          />
          <span
            style={{
              fontFamily: "Mazzard",
              color: "#272727",
              fontWeight: "600",
            }}
          >
            Learners have no incorrectly answered questions
          </span>
        </div>
      );
    }
  };

  return (
    <div className="dash-resultOverview">
      <div className="dash-resultHeader">
        <img
          className="dashboardoverlayclose-btn"
          src={backArrow}
          alt="Back"
          onClick={() => {
            dispatch(setSelectedToggle("Assessments Results"));

            if (location.state.assessmentId) {
              navigate("/dashboard/student/skills-details", { state });
              return;
            }
            navigate(-1);
          }}
        />{" "}
        <div className="dash-resultText">Result Overview</div>
      </div>
      <div className="horizontal-divider" />
      <div>
        <div className="dash-resultScoreHeader">
          <div className="dash-resultScoreHeaderLeft">
            <div className="dash-resultModuleName">
              {state.domain_data?.domain_name}
            </div>

            <Tooltip
              title={
                <div style={{ padding: "4px 8px" }}>
                  <div
                    style={{
                      fontSize: "14px",
                      fontFamily: "Mazzard",
                      fontWeight: "500",
                      marginBottom: "2px",
                    }}
                  >
                    {/* {item.title} */}
                    {state.domain_data.domain_name}
                  </div>

                  <div style={{ fontFamily: "Mazzard" }}>
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "80px",
                          fontWeight: "bold",
                        }}
                      >
                        Assessment:
                      </div>
                      <div style={{ flex: 1 }}>
                        {state.data.assessment_name}
                      </div>
                    </div>

                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "80px",
                          fontWeight: "bold",
                        }}
                      >
                        Date:
                      </div>
                      <div style={{ flex: 1 }}>
                        {state.data.submitted_date?.split(",")[0]}
                      </div>
                    </div>

                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "80px",
                          fontWeight: "bold",
                        }}
                      >
                        Duration:
                      </div>
                      <div style={{ flex: 1 }}>{state.data.duration}</div>
                    </div>
                  </div>
                </div>
              }
              arrow
              placement="top"
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "rgba(68, 68, 68, 1)",
                    width: "250px",
                    height: "100px",
                    overflowY: "auto",
                    "&::-webkit-scrollbar": {
                      width: "1px",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "grey",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "transparent",
                    },
                  },
                },
                arrow: {
                  sx: {
                    color: "rgba(68, 68, 68, 1)",
                  },
                },
              }}
            >
              <img
                src={info}
                alt="info"
                style={{
                  height: "18px",
                  width: "18px",
                  marginTop: "6px",
                  marginLeft: "5px",
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          </div>
          <div className="dash-resultScoreHeaderRight">
            <div className="dash-correctAnswerText">
              Correct Answers : {correctCount}/{totalCount}
            </div>
            <div
              className="dash-resultScoreBar"
              style={{
                backgroundColor: getDomainScoreUI(domainScore).backgroundColor,
              }}
            >
              <div
                style={{
                  fontFamily: "Mazzard",
                  color: "#ffffff",
                  fontWeight: "600",
                  fontSize: "20px",
                }}
              >
                {domainScore}%
              </div>
              {/* <div className="vertical-divider"></div> */}

              {/* <div
                style={{
                  fontFamily: "Mazzard",
                  color: "#ffffff",
                  fontSize: "20px",
                  fontWeight: "400",
                }}
              >
                {getDomainScoreUI(domainScore).label}
              </div> */}
            </div>
          </div>
        </div>
        <div className="horizontal-divider" />
        <div className="dash-detailOverViewHeader">
          {questions.length !== 0 ? (
            <div className="dash-detailOverViewLeft">Detailed Analysis</div>
          ) : (
            <div className="dash-detailOverViewLeft"></div>
          )}
          <div className="dash-detailOverViewRight">
            <div className="dash-result-toggle-container">
              {toggleOptions.map((option) => (
                <button
                  key={option.id}
                  className={`dash-result-toggle-option ${selectedOption === option.id ? "active" : ""
                    }`}
                  onClick={() => {
                    resultOverviewApi(option.id);
                    setSelectedOption(option.id);
                  }}
                >
                  <span className="dash-result-toggle-label">
                    {option.label}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="dash-resultQuestionContainer">
          <div className="dash-resultScore-rightPanel">
            {questions.length !== 0
              ? questions.map((q: AssessmentQuestionResult, index) => {
                // Check question type and render accordingly
                if (q.question_type === "Sql") {
                  return renderSqlQuestion(q, index);
                } else if (q.question_type === "Programming") {
                  return renderProgrammingQuestion(q, index);
                } else {
                  return renderMultipleChoiceQuestion(q, index);
                }
              })
              : renderEmptyState()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultOverView;
